<template>
  <svg :class="className" :width="width" :height="height" :viewBox="viewBox" :fill="fill" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.40954 7.29622L8.40954 1.25249C8.40954 1.02717 8.48562 0.838436 8.63777 0.686283C8.79046 0.533599 8.97946 0.457256 9.20477 0.457256C9.43009 0.457256 9.61909 0.533599 9.77177 0.686283C9.92392 0.838436 10 1.02717 10 1.25249L10 9.20477C10 9.43009 9.92392 9.61909 9.77177 9.77177C9.61909 9.92392 9.43009 10 9.20477 10L1.25249 10C1.02717 10 0.838436 9.92392 0.686283 9.77177C0.533599 9.61908 0.457256 9.43009 0.457256 9.20477C0.457256 8.97946 0.533599 8.79046 0.686283 8.63777C0.838436 8.48562 1.02717 8.40954 1.25249 8.40954L7.29622 8.40954L0.21869 1.33201C0.0728977 1.18622 7.86747e-07 1.00066 8.06445e-07 0.775347C8.26142e-07 0.550033 0.0728978 0.36448 0.21869 0.218688C0.364482 0.0728961 0.550034 -8.26142e-07 0.775349 -8.06445e-07C1.00066 -7.86747e-07 1.18622 0.0728962 1.33201 0.218688L8.40954 7.29622Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'ArrowIcon',
  props: {
    className: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '10',
    },
    height: {
      type: String,
      default: '10',
    },
    viewBox: {
      type: String,
      default: '0 0 10 10',
    },
    fill: {
      type: String,
      default: 'none',
    },
  },
};
</script>
